import React, { createContext, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { getErrorMessageFromError } from "../../components/ErrorMessage";
import { useApp } from "../../hooks/useApp";
import { ClientDto } from "../../model/ClientDto";
import {
  ClientDelete,
  ClientListRequest,
  ClientPipelineTotals,
  ClientSaveRequest,
  ClientUpdatedRequest,
  UpdateLead,
} from "../../services/client/ClientService";
import { useSidebarData } from "../global/SidebarDataContext";

import { getMessageTemplateRequest } from "../../services/templates/MessageTemplatesService";
import { TemplateDto } from "../../model/TemplatesDto";

const ClientsLeadsNuevoDataContext = createContext();

const ClientsLeadsNuevoDataContextProvider = ({ children }) => {
  const [listClientsLeads, setListClientsLeads] = useState([]);
  const [updateLead, setUpdateLead] = useState(false);
  const [dataUpload, setDataUpload] = useState({});
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [clientIdToDelete, setClientIdToDelete] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [company, setCompany] = useState(" ");
  const [countryPhone, setCountryPhone] = useState(null);
  const [customerStatus, setCustomerStatus] = useState(null);
  const [leadTag, setLeadTag] = useState(null);
  const [leadTagFilter, setLeadTagFilter] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [isFirstRenderRowsPerPage, setIsFirstRenderRowsPerPage] =
    useState(true);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [clientActive, setClientActive] = useState(true);
  const [templatesTwilio, setTemplatesTwilio] = useState([]);
  const [templatesEmail, setTemplatesEmail] = useState([]);
  const [pipelineTotals, setPipelineTotals] = useState({});

  const navigate = useNavigate();
  const { notificationsWS } = useSidebarData();

  const {
    loading,
    setLoading,
    setSuccessMsg,
    setErrorMsg,
    messageUser,
    authenticate,
    authInfo,
  } = useApp();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  useEffect(() => {
    if (authenticate && authInfo) {
      setTimeout(() => loadClientsLeads(), 100);
    }
  }, [page, authenticate, authInfo]);

  useEffect(() => {
    if (isFirstRenderRowsPerPage) setIsFirstRenderRowsPerPage(false);
    else {
      if (page == 0) setTimeout(() => loadClientsLeads(), 100);
      else setPage(0);
    }
  }, [rowsPerPage]);

  const handleCancel = () => {
    navigate(-1);
    setCountryPhone(null);
    setCustomerStatus(null);
    setLeadTag(null);
  };

  const loadClientsLeads = async () => {
    try {
      setLoading(true);
      const statusClient =
        authInfo?.userRole?.id === 1
          ? clientActive
            ? "ACTIVE"
            : "DELETED"
          : "ACTIVE";
      // Format dates for API
      const formatDateForApi = (date) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const [responseClientsList, totals] = await Promise.all([
        ClientListRequest(
          1,
          page,
          rowsPerPage,
          company,
          authInfo.id,
          authInfo.userRole.id,
          statusClient,
          countryPhone ? countryPhone.id : 0,
          searchInput,
          leadTagFilter ? leadTagFilter.id : null,
          formatDateForApi(startDate),
          formatDateForApi(endDate)
        ),
        ClientPipelineTotals(
          1,
          authInfo.id,
          authInfo.userRole.id,
          company,
          statusClient,
          countryPhone ? countryPhone.id : 0,
          searchInput,
          leadTagFilter ? leadTagFilter.id : null,
          formatDateForApi(startDate),
          formatDateForApi(endDate)
        ).catch((err) => {
          console.error('[PipelineTotals] error:', err?.response?.status, err?.response?.data || err?.message);
          return {};
        }),
      ]);

      setPipelineTotals(totals || {});
      setTotalItems(responseClientsList.totalElements);
      const clients = responseClientsList.content.map((clientData) => {
        const leadTagName = clientData.leadTags && clientData.leadTags.length > 0
          ? clientData.leadTags[0].name
          : clientData.leadTagName;

        const leadTagId = clientData.leadTagIds && clientData.leadTagIds.length > 0
          ? clientData.leadTagIds[0]
          : clientData.leadTagId;

        const dto = new ClientDto(
          clientData.id,
          clientData.name,
          clientData.cellPhone,
          clientData.email,
          clientData.prospect,
          clientData.jobTitle,
          clientData.company,
          clientData.company_name,
          clientData.status,
          clientData.countryPhone,
          clientData.lastContactDate,
          clientData.lastContactChannel,
          clientData.customerStatusId,
          clientData.customerStatusName,
          leadTagName,
          leadTagId,
          clientData.enableAiAssistant,
          clientData.leadTags || [],
          clientData.leadTagIds || [],
          clientData.meetingDate,
          clientData.proposalDate,
          clientData.notes,
          clientData.value,
          clientData.userId,
          clientData.ownerName,
          clientData.businessName,
          clientData.giro,
          clientData.website,
          clientData.origin,
          clientData.createdAt
        );
        return dto;
      });
      setListClientsLeads(clients);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorMessage = getErrorMessageFromError(error);
      setErrorMsg(errorMessage);

      setLoading(false);
    }
  };

  const handleFormSubmit = async (values) => {
    if (!countryPhone || !countryPhone.id || countryPhone.id == 0) {
      setErrorMsg("País es un campo requerido.");
      return;
    }
    values.countryPhone = countryPhone;
    values.customerStatusId = customerStatus?.id || null;
    values.customerStatusName = customerStatus?.name || "";
    values.leadTagId = leadTag?.id || null;
    values.leadTagName = leadTag?.name || "";
    try {
      const input = {
        ...values,
      };
      setLoading(true);
      if (values.id) {
        await ClientUpdatedRequest(input);
        setSuccessMsg("Editado con éxito");
      } else {
        await ClientSaveRequest(input);
        setSuccessMsg("Creado con éxito");
      }
      setPage(0);
      setLoading(false);
      handleCancel();
      stopEditing();
    } catch (error) {
      const errorMessage = getErrorMessageFromError(error);
      setErrorMsg(errorMessage);

      setLoading(false);
    }
  };

  const updatedLead = async () => {
    setUpdateLead(false);
    try {
      const input = {
        ...dataUpload,
        prospect: 0,
      };
      setLoading(true);
      // eslint-disable-next-line no-unused-vars
      const data = await UpdateLead(input);
      setSuccessMsg("Ascendido con éxito");
      setLoading(false);
      if (page == 0) setTimeout(() => loadClientsLeads(), 100);
      else setPage(0);
    } catch (error) {
      const errorMessage = getErrorMessageFromError(error);
      setErrorMsg(errorMessage);
    }
  };

  const handleDelete = async (clientId) => {
    try {
      setLoading(true);
      await ClientDelete(clientId);
      setSuccessMsg("Eliminado con éxito");
      if (page == 0) setTimeout(() => loadClientsLeads(), 100);
      else setPage(0);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const errorMessage = getErrorMessageFromError(error);
      setErrorMsg(errorMessage);
    }
  };

  const startEditing = (initialValues) => {
    setIsEditing(true);
    setFormData(initialValues);
  };

  const stopEditing = () => {
    setIsEditing(false);
    setFormData(null);
  };

  const openDeleteConfirmation = (clientId) => {
    setClientIdToDelete(clientId);
    setShowDeleteConfirmation(true);
  };

  const closeDeleteConfirmation = () => {
    setClientIdToDelete(null);
    setShowDeleteConfirmation(false);
  };

  const handleDeleteConfirmed = async () => {
    closeDeleteConfirmation();
    if (clientIdToDelete) {
      await handleDelete(clientIdToDelete);
    }
  };

  const onClickMarkChatUnread = (params) => {
    if (messageUser.some((item) => item.client.id === params.row.id)) {
      navigate("/dashboard/whatsapp", { state: params.row });
    }
  };

  const handleChangeClientActive = (event) => {
    setClientActive(event.target.checked);
  };

  const handleDateRangeChange = (newStartDate, newEndDate) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const loadTemplates = async () => {
    try {
      const whatsappTwilio = {
        type: "WHATSAPP_TWILIO",
        active: true,
        page: 0,
        size: 100,
        authorized: true,
      };
      const responseDataTwilio = await getMessageTemplateRequest(
        whatsappTwilio
      );
      const templateInstancesTwilio = responseDataTwilio.content.map(
        (templateData) => {
          return new TemplateDto(
            templateData.id,
            templateData.template,
            templateData.name,
            templateData.type,
            templateData.active,
            templateData.authorized,
            templateData.contentSidTwilio,
            templateData.nameTemplateTwilio
          );
        }
      );

      setTemplatesTwilio(templateInstancesTwilio);

      // Cargar plantillas EMAIL
      try {
        const emailParams = { type: "EMAIL", active: true, page: 0, size: 100 };
        const responseEmail = await getMessageTemplateRequest(emailParams);
        setTemplatesEmail(
          (responseEmail.content || []).map((t) => ({
            id: t.id,
            name: t.name,
            subject: t.subject || "",
            template: t.template,
            type: t.type,
            active: t.active,
          }))
        );
      } catch (_) {}
    } catch (error) { }
  };

  useEffect(() => {
    if (page == 0 && authInfo?.userRole?.id != undefined)
      setTimeout(() => loadClientsLeads(), 100);
    else setPage(0);
  }, [clientActive]);

  // Date filter effect
  useEffect(() => {
    if (authInfo?.userRole?.id != undefined) {
      if (page === 0) setTimeout(() => loadClientsLeads(), 100);
      else setPage(0);
    }
  }, [startDate, endDate]);

  //Notifications WebSocket
  useEffect(() => {
    if (notificationsWS?.messageIncoming && notificationsWS?.client?.id) {
      loadClientsLeads();
    }
  }, [notificationsWS]);

  //Load init
  useEffect(() => {
    loadTemplates();
  }, []);

  return (
    <ClientsLeadsNuevoDataContext.Provider
      value={{
        listClientsLeads,
        setListClientsLeads,
        updateLead,
        setUpdateLead,
        dataUpload,
        setDataUpload,
        handleCancel,
        loading,
        messageUser,
        loadClientsLeads,
        updatedLead,
        handleFormSubmit,
        handleDelete,
        isEditing,
        formData,
        showDeleteConfirmation,
        startEditing,
        stopEditing,
        onClickMarkChatUnread,
        openDeleteConfirmation,
        closeDeleteConfirmation,
        handleDeleteConfirmed,
        company,
        setCompany,
        countryPhone,
        setCountryPhone,
        customerStatus,
        setCustomerStatus,
        leadTag,
        setLeadTag,
        leadTagFilter,
        setLeadTagFilter,
        searchInput,
        setSearchInput,
        setSuccessMsg,
        setErrorMsg,
        page,
        setPage,
        rowsPerPage,
        handleChangePage,
        handleChangeRowsPerPage,
        totalItems,
        authenticate,
        authInfo,
        handleChangeClientActive,
        clientActive,
        templatesTwilio,
        templatesEmail,
        startDate,
        endDate,
        handleDateRangeChange,
        pipelineTotals,
      }}
    >
      {children}
    </ClientsLeadsNuevoDataContext.Provider>
  );
};

export { ClientsLeadsNuevoDataContext, ClientsLeadsNuevoDataContextProvider };
